import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../contexts/AuthContext';
import AndroidRaceRoom from '../features/raceRoom/AndroidRaceRoom';

export default function RaceRoomPage() {
  const { user, profile } = useAuth();
  return (
    <main className="p4r-race-page">
      <Helmet>
        <title>Race Room | Pool 4 Real</title>
        <meta name="description" content="Run a live pool or billiards match with player cards, score tracking, timers, game settings, saved sessions, and a fullscreen TV scoreboard." />
      </Helmet>
      <AndroidRaceRoom user={user} profile={profile} />
    </main>
  );
}
